import { combineReducers } from 'redux';

import { FETCH_DEVICES_APP_REQUEST } from 'modules/devices/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import data from './data';

export default combineReducers({
  loading: loading(FETCH_DEVICES_APP_REQUEST),
  data,
});
